export default __webpack_public_path__ + "static/media/img10.c2266d71.jpg";